import { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "./Navbar.css";

function Navbar() {
  const { logout } = useAuth();

  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="navbar">

      <div className="navbar-top">

        <div className="navbar-logo">
          <Link to="/dashboard">
            CompExams
          </Link>
        </div>

        <button
          className="hamburger"
          onClick={() =>
            setMenuOpen(!menuOpen)
          }
        >
          ☰
        </button>

      </div>

      <div
        className={`navbar-content ${
          menuOpen ? "active" : ""
        }`}
      >

        <div className="navbar-links">

          <Link
            to="/dashboard"
            onClick={() => setMenuOpen(false)}
          >
            Dashboard
          </Link>

          <div className="dropdown">

            <button className="dropdown-btn">
              Categories
            </button>

            <div className="dropdown-content">

              <Link
                to="/categories/create"
                onClick={() => setMenuOpen(false)}
              >
                Create Category
              </Link>

              <Link
                to="/categories/manage"
                onClick={() => setMenuOpen(false)}
              >
                Manage Categories
              </Link>

            </div>

          </div>

          <div className="dropdown">

            <button className="dropdown-btn">
              Exams
            </button>

            <div className="dropdown-content">

              <Link
                to="/exams/create"
                onClick={() => setMenuOpen(false)}
              >
                Create Exam
              </Link>

              <Link
                to="/exams/manage"
                onClick={() => setMenuOpen(false)}
              >
                Manage Exams
              </Link>

            </div>

          </div>

          <div className="dropdown">

            <button className="dropdown-btn">
              Ads
            </button>

            <div className="dropdown-content">

              <Link
                to="/ads/create"
                onClick={() => setMenuOpen(false)}
              >
                Create Ad
              </Link>

              <Link
                to="/ads/manage"
                onClick={() => setMenuOpen(false)}
              >
                Manage Ads
              </Link>

            </div>

          </div>

        </div>

        <div className="navbar-user">

          <div className="avatar">
            A
          </div>

          <button
            className="logout-btn"
            onClick={logout}
          >
            Logout
          </button>

        </div>

      </div>

    </nav>
  );
}

export default Navbar;